module.exports = __webpack_public_path__ + "static/img/index12.eb72332.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index12.gif
// module id = FA/v
// module chunks = 0